import { useCallback } from 'react';

import { nanoid } from 'nanoid';

import useDrawer from '../../../../../hooks/useDrawer';
import type { GeoCoordinates } from '../../../../../shared/types';
import { Drawer } from '../../../../../state/drawer';
import { TypeLocation, type LocationForm } from '../../../../../state/locationsForm';

export function useLocationFormDrawer() {
  const { showDrawer } = useDrawer();

  const onMapClick = useCallback(
    (latLng: GeoCoordinates) => {
      showDrawer({
        type: Drawer.EVENT_LOCATION,
        props: {
          locationForm: {
            type: TypeLocation.New,
            key: nanoid(),
            geo: latLng,
          },
        },
      });
    },
    [showDrawer],
  );

  const onMarkerClick = useCallback(
    (location: LocationForm) => () => {
      showDrawer({
        type: Drawer.EVENT_LOCATION,
        props: {
          locationForm: location,
        },
      });
    },
    [showDrawer],
  );

  return {
    onMarkerClick,
    onMapClick,
  };
}
